import { lazify } from "../lazify";

export function SidePanel() {
	return (
        <Audit></Audit>
	);
}

// @ts-ignore
const Audit = lazify(() => import("../audit/audit"));
